<template>
  <v-col cols="12" sm="6" lg="4">
    <v-sheet elevation="1" class="pa-4" style="position:relative;">
      <h3 class="headline mb-2">{{ headline }}</h3>
      <!-- <v-btn icon class="editBtn">
        <v-icon>{{ editSvg }}</v-icon>
      </v-btn> -->
      <v-row dense v-for="record in records" :key="record.name">
        <v-col cols="5">
          <strong>{{ record.label }}</strong>
        </v-col>
        <v-col>{{
          typeof record.value === "boolean"
            ? record.value
              ? "✔️"
              : "❌"
            : record.value || "-"
        }}</v-col>
      </v-row>
    </v-sheet>
  </v-col>
</template>

<script>
// import { mdiPencil } from "@mdi/js";

export default {
  name: "card",
  props: ["headline", "records"]
  // data: () => ({
  //   editSvg: mdiPencil
  // })
};
</script>

<style scoped lang="scss">
// .editBtn {
//   position: absolute;
//   top: map-get($spacers, 3);
//   right: map-get($spacers, 3);
// }
</style>
